import {
  FileUpload as ChakraFileUpload,
  useFileUpload as chakraUseFileUpload,
} from '@chakra-ui/react'

export const FileUploadRootProvider = ChakraFileUpload.RootProvider
export const FileUploadRoot = ChakraFileUpload.Root
export const FileUploadList = ChakraFileUpload.List
export const FileUploadHiddenInput = ChakraFileUpload.HiddenInput
export const FileUploadTrigger = ChakraFileUpload.Trigger
export const FileUploadDropzone = ChakraFileUpload.Dropzone
export const FileUploadDropzoneContent = ChakraFileUpload.DropzoneContent
export const FileUploadItem = ChakraFileUpload.Item
export const FileUploadItemDeleteTrigger = ChakraFileUpload.ItemDeleteTrigger

export type UseFileUploadReturn = ReturnType<typeof chakraUseFileUpload>
export const useFileUpload = chakraUseFileUpload
